import { Log, User, UserManager } from 'oidc-client';
import axios from 'axios';

let authority = 'https://auth.local';
if (process.env.NODE_ENV === 'production') {
    authority = 'https://login.laud-media.com';
}

export interface OidcServiceParameters {
    redirectUri: string;
    silentRedirectUri: string;
    postLogoutRedirectUri: string;
    clientId: string;
}

export class OidcService {
    public userManager: UserManager;

    constructor({
        redirectUri,
        silentRedirectUri,
        postLogoutRedirectUri,
        clientId
    }: OidcServiceParameters) {
        const settings = {
            authority: authority,
            client_id: clientId,
            redirect_uri: redirectUri,
            silent_redirect_uri: silentRedirectUri,
            post_logout_redirect_uri: postLogoutRedirectUri,
            response_type: 'id_token token',
            scope: 'openid email lmapi',
            loadUserInfo: false
        };
        this.userManager = new UserManager(settings);

        Log.logger = console;
        Log.level = Log.INFO;
    }

    public getUser(): Promise<User> {
        return this.userManager.getUser();
    }

    public login(): Promise<void> {
        return this.userManager.signinRedirect();
    }

    public loginCallback(url?: string): Promise<any> {
        return this.userManager.signinRedirectCallback(url);
    }

    public renewToken(): Promise<User> {
        return this.userManager.signinSilent();
    }

    public logout(): Promise<void> {
        return this.userManager.signoutRedirect();
    }
}

export class AuthServiceApi {
    constructor() {
        axios.defaults.baseURL = authority;
    }
    public getApplications() {
        return axios.get('/api/applications');
    }

    public changePassword(email: string) {
        return axios.post('/account/forgotpasswordjson', {
            email: email
        });
    }

    public setToken(token: string) {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    }
}



// WEBPACK FOOTER //
// ./src/Authservice.ts